import script from "./edit-user-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-user-modal.vue?vue&type=script&setup=true&lang=ts"

import "./edit-user-modal.vue?vue&type=style&index=0&id=538572e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538572e8"]])

export default __exports__